import { AditivoConvenio } from '@/types/licitacoes/aditivo-convenio/aditivo-convenio';
import { FiltrosAditivosConvenio } from '@/types/licitacoes/aditivo-convenio/filtros-aditivos-convenio';
import { PortalError } from '@/types/portal-error';
import { Service } from '../mainService';

const aditivosConvenioService = {
    buscarAditivo,
    adicionarAditivo,
    editarAditivo,
    buscarAditivos,
    removerAditivo,
    listarConvenios,
    listarTiposAditivo,
    listarNaturezasAjuste,
    baixarAnexo,
    listarLogs,
    importarXml,
    baixarRelatorioDeInconsistencias,
    filtrarAditivos
}

async function buscarAditivos(page, pageSize) {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/listar?page=" + page + "&pageSize=" + pageSize
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarAditivo(id: string) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/buscar/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function baixarAnexo(id) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/baixaranexo/" + id, { responseType: "blob" });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarLogs(id: number) {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/listarLogs/" + id
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarConvenios() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/listarConvenios/"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarTiposAditivo() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/listarTiposAditivo/"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarNaturezasAjuste() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/listarNaturezasAjuste/"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarAditivo(infoAditivo: AditivoConvenio, arquivo: any) {
    try {
        const data = new FormData();
        data.append('IdConvenio', infoAditivo.IdConvenio.toString())
        data.append('IdNaturezaAjuste', infoAditivo.IdNaturezaAjuste.toString())
        data.append('NrAditivo', infoAditivo.NrAditivoConvenio.toString())
        data.append('AnoAditivo', infoAditivo.NrAnoAditivoConvenio.toString())
        data.append('DeJustificativa', infoAditivo.DeJustificativaAditivo)
        if(infoAditivo.DtAnulacaoAditivo)
            data.append('DtAnulacao', infoAditivo.DtAnulacaoAditivo.toISOString())
        if(infoAditivo.DeMotivoAnulacaoAditivo)
            data.append('DeMotivoAnulacao', infoAditivo.DeMotivoAnulacaoAditivo.toString())
        if(infoAditivo.DtInicioVigenciaAditivo)
            data.append('DtInicioVigencia', infoAditivo.DtInicioVigenciaAditivo.toISOString())
        if(infoAditivo.DtFimVigenciaAditivo)
            data.append('DtFimVigencia', infoAditivo.DtFimVigenciaAditivo.toISOString())
        if(infoAditivo.VlAditivoConvenio)
            data.append('VlAditivo', infoAditivo.VlAditivoConvenio.toString())
        data.append('DtCelebracao', infoAditivo.DtCelebracaoAditivo.toISOString())
        data.append('DtPublicacao', infoAditivo.DtPublicacaoAditivo.toISOString())
        data.append('ArquivoTextoAditivo', arquivo)
        
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/adicionar", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function editarAditivo(infoAditivo: AditivoConvenio, arquivo: any) {
    try {
        const data = new FormData();
        data.append('IdConvenio', infoAditivo.IdConvenio.toString())
        data.append('IdNaturezaAjuste', infoAditivo.IdNaturezaAjuste.toString())
        data.append('NrAditivo', infoAditivo.NrAditivoConvenio.toString())
        data.append('AnoAditivo', infoAditivo.NrAnoAditivoConvenio.toString())
        data.append('DeJustificativa', infoAditivo.DeJustificativaAditivo)
        if(infoAditivo.DtAnulacaoAditivo)
            data.append('DtAnulacao', infoAditivo.DtAnulacaoAditivo.toISOString())
        if(infoAditivo.DeMotivoAnulacaoAditivo)
            data.append('DeMotivoAnulacao', infoAditivo.DeMotivoAnulacaoAditivo.toString())
        if(infoAditivo.DtInicioVigenciaAditivo)
            data.append('DtInicioVigencia', infoAditivo.DtInicioVigenciaAditivo.toISOString())
        if(infoAditivo.DtFimVigenciaAditivo)
            data.append('DtFimVigencia', infoAditivo.DtFimVigenciaAditivo.toISOString())
        if(infoAditivo.VlAditivoConvenio)
            data.append('VlAditivo', infoAditivo.VlAditivoConvenio.toString())
        data.append('DtCelebracao', infoAditivo.DtCelebracaoAditivo.toISOString())
        data.append('DtPublicacao', infoAditivo.DtPublicacaoAditivo.toISOString())
        if(arquivo)
            data.append('ArquivoTextoAditivo', arquivo)
        
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/editar/"+infoAditivo.IdAditivoConvenio, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function importarXml(arquivo) {
    try {
        const data = new FormData();
        data.append("zipFile", arquivo);
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/importar/xml", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function baixarRelatorioDeInconsistencias(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/relatoriodeinconsistencias", data, { responseType: "blob" });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerAditivo(id: number) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_LICITACOES_API + "/aditivoConvenio/remover/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function filtrarAditivos(page: number, pageSize: number, filtros: FiltrosAditivosConvenio): Promise<any> {
    const url = `${process.env.VUE_APP_LICITACOES_API}/aditivoConvenio/filtrarAditivos?page=${page}&pageSize=${pageSize}${filtros.toQueryString()}`
    const response = await Service.$http.get(url);
    if (response && response.status === 200) {
        return response.data
    } else {
        throw new PortalError(response.data?.msg || 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
    }
}

export default aditivosConvenioService;